import React from 'react';

interface CheckboxIconProps {
  size?: number | string;
  color?: string;
  checked?: boolean;
  indeterminate?: boolean;
}

export const CheckboxIcon: React.FC<CheckboxIconProps> = ({
  size = 24,
  color = 'currentColor',
  checked = false,
  indeterminate = false,
}) => {
  if (indeterminate) {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          className="indeterminate-icon-rect-1"
          x="2"
          y="2"
          width="20"
          height="20"
          rx="6"
          ry="6"
          stroke={color}
          strokeWidth="1"
          fill={color}
        />
        <rect className="indeterminate-icon-rect-2" x="6" y="11" width="12" height="2" fill="white" />
      </svg>
    );
  }

  if (checked) {
    return (
      <svg
        className="checked-icon"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="2" y="2" width="20" height="20" rx="6" ry="6" stroke={color} strokeWidth="1" fill={color} />
        <path
          d="M7 12l2.5 2.5 6.5-6.5"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        className="unchecked-icon"
        x="2"
        y="2"
        width="20"
        height="20"
        rx="6"
        ry="6"
        stroke="#D0D5DD"
        strokeWidth="1"
        fill="none"
      />
    </svg>
  );
};
